import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Chip,
  FormHelperText,
  DialogActions,
} from '@material-ui/core';
import React, { useEffect, useState, useContext } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { numberWithCommas, removeEmptyValueObject } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';
import List from './listHelpical';
import { useHistory } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getTicketsAction,
  getTicketsCountAction,
} from '../../pages/orders/actions';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectTicketCountList,
  makeSelectTicketsList,
} from '../../pages/orders/selectors';
import { SelectorProps, Payload } from '../../pages/orders/interfaces';
import { Store } from '../../redux/reducers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import {
  PostAllTicketsRequestBuilder,
  FileUploadTicketsRequestBuilder,
} from 'client-sdk/src/helpical/categories';
import handleNotfication from '../../utils/handleNotfication';
import { useForm, Controller } from 'react-hook-form';
import { Autocomplete } from '@material-ui/lab';

import windowSize from '../../utils/hook/useWindowResize';
import { RonadDropzone } from '../RonadDropzone';
import getAllCategories from '../../requests/getAllCategories';
import AuthContext from '../../authContext';
import { Client } from 'client-sdk/src';
import getAllTickets from './getAllTickets';
import RonadIcons from '../iconComponent';
import CounterCard from '../Cards/counterCard';

const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];

const ticketType = [
  {
    id: 0,
    name: 'ORDER',
    title: 'سفارش',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'PARCEL',
    title: 'محموله',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'NONE',
    title: 'هیچکدام',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
];

const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    mainContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px"
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      cursor: "pointer"
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-40px',
      display: 'flex',
      textAlign: 'center',
      paddingBottom: "12px !important"
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    icon: {
      backgroundColor: "#f5f5f5",
      padding: "10px"
    }
  })
);

const Helpdesk = props => {
  const { search } = useLocation();

  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    ...queryString.parse(search)
  });
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [countError, setCountError] = useState<string>('');
  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        type: "NONE",
        file: null,
        title: null,
        priority: '',
        subject: '',
        msg: '',
        category: '',
        'parcel-order-number': props.match.params.id
          ? props.match.params.id
          : '',
      },
    });
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token') || '';

  const [depts, setDepts] = useState<any[]>([
    { "id": 51, "name": "عملیات و انبار", "helpicalId": 11 },
    { "id": 52, "name": "ارسال و سفارشات", "helpicalId": 12 },
    { "id": 53, "name": "مالی", "helpicalId": 13 },
    { "id": 54, "name": "فنی", "helpicalId": 14 }
  ]);
  const [activeDepartment, setActiveDepartment] = useState<
    string | null | undefined
  >('');
  const [categories, setCategories] = useState<any[]>([]);

  const [activeCategory, setCategory] = useState<number | null | undefined>(
    undefined
  );
  const [finalizedTicketsList, setFinalTickets] = useState<any>([]);
  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };

  const handleFileDropped = (acceptedFile: any) => {
    setFile(acceptedFile);
  };

  const onSubmit = async data => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append('file', file);
      const makeRequest = new PostAllTicketsRequestBuilder()
        .params({})
        .data({
          orderId: data.type == 'ORDER' ? getValues('parcel-order-number') : null,
          parcelId: data.type == 'PARCEL' ? getValues('parcel-order-number') : null,
          categoryId: activeCategory,
          message: data.msg,
          importance: data.priority,
          subject: data.title,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(response.data.id)
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      getTickets()
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);
    }
  };

  useEffect(() => {
    setValue("parcel-order-number", "")
  }, [watch('type')]);

  useEffect(() => {
    getTickets();
    getTicketsCount();
    getingTicketCount(request);
  }, [filtersValues]);

  // useEffect(() => {
  //   const response = getAllDepartments();
  //   response.then(deptResponse => {
  //     setDepts(deptResponse.data);
  //   });
  // }, []);

  useEffect(() => {
    if (authContext.user.role !== 'SELLER_ADMIN') {
      try {
        handleActiveDeptChange();
      } catch {
        // console.log("WHOOPSY!");
      }
    }
  }, [activeDepartment]);

  const handleActiveDeptChange = () => {
    if (activeCategory) {
      setCategory(undefined);
      setValue('category', undefined);
    }
    if (activeDepartment) {
      const response = getAllCategories({
        helpicalDepartmentId: activeDepartment,
      });
      response.then(catResponse => {
        setCategories(catResponse.data);
        // console.log('categories by id: ', catResponse.data);
      });
    }
  };

  const checkActiveCard = name => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'answered':
        return status.includes('ATTENDEE_ANSWERED');
      case 'open':
        return status.includes('OPEN');
      case 'closed':
        return status.includes('CLOSED');
      case 'owner-answered':
        return status.includes('OWNER_ANSWERED');
    }
  };

  const handleCardClose = () => {
    const newFilterValues = { ...filtersValues };
    delete newFilterValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(newFilterValues),
      page: 0,
      size: 10,
    });
  };

  const handleCardClick = name => {
    switch (name) {
      case 'answered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ATTENDEE_ANSWERED'],

          page: 0,
          size: 10,
        });
        break;
      case 'open':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['OPEN'],

          page: 0,
          size: 10,
        });
        break;
      case 'closed':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['CLOSED'],
          page: 0,
          size: 10,
        });
        break;
      case 'owner-answered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['OWNER_ANSWERED'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const getTickets = () => {
    getAllTickets({ ...filtersValues }).then(response => {
      setFinalTickets(response.data);
    }).catch(error => {
      handleError(error)
    })
  };
  const getTicketsCount = () => {
    const { page, size } = filtersValues;
    props.ticketCountDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const getingTicketCount = async (actions: any) => {
    try {
      setLoading(true);

      const { response: openCount } =
        await ordersRepository.getHelpicalTicketsCount({
          payload: actions.openCount,
        });
      const { response: closeCount } =
        await ordersRepository.getHelpicalTicketsCount({
          payload: actions.closeCount,
        });
      const { response: answeredCount } =
        await ordersRepository.getHelpicalTicketsCount({
          payload: actions.answeredCount,
        });
      const { response: ownerAnsweredCount } =
        await ordersRepository.getHelpicalTicketsCount({
          payload: actions.ownerAnsweredCount,
        });
      setCardCounts({
        openCount,
        closeCount,
        answeredCount,
        ownerAnsweredCount,
      });
    } catch (error) {
      setCountError(error.message);
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      'status.in': 'OPEN',
    },
    closeCount: {
      'status.in': 'CLOSED',
    },
    answeredCount: {
      'status.in': 'ATTENDEE_ANSWERED',
    },
    ownerAnsweredCount: {
      'status.in': 'OWNER_ANSWERED',
    },
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
    setFile(null);
    // console.log("IN CLOSE MODAL");
    setValue('file', null);
    setCategories([]);
    setCategory(null);
    setValue('category', '');
    setActiveDepartment(undefined);
  };

  return (
    <React.Fragment>
      <p className='typography-cards'>
        پشتیبانی
      </p>
      <div className={classes.mainContainer}>
        <Grid container spacing={2} style={{marginBottom: "24px"}}>
          <Grid item md={6} lg={3} xs={12}>
            <CounterCard
              isActive={checkActiveCard('answered')}
              data={numberWithCommas(cardCounts.answeredCount?.data)}
              handleClick={() => handleCardClick('answered')}
              label="پاسخ داده شده"
              icon="mailUnread"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <CounterCard
              isActive={checkActiveCard('open')}
              data={numberWithCommas(cardCounts.openCount?.data)}
              handleClick={() => handleCardClick('open')}
              label="مشاهده شده"
              icon="mailOpen"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <CounterCard
              isActive={checkActiveCard('owner-answered')}
              data={numberWithCommas(cardCounts.ownerAnsweredCount?.data)}
              handleClick={() => handleCardClick('owner-answered')}
              label="در حال انجام"
              icon="mailAnswered"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <CounterCard
              isActive={checkActiveCard('closed')}
              data={numberWithCommas(cardCounts.closeCount?.data)}
              handleClick={() => handleCardClick('closed')}
              label="بسته شده"
              icon="mailOutline"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
        </Grid>
          {/* <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{marginBottom: "24px"}}
          >
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => setOpenMsg(true)}
              >
                {`تیکت جدید`}
              </Button>
            </Grid>
          </Grid> */}
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {finalizedTicketsList?.length > 0 ? (
                <List
                  data={
                    finalizedTicketsList
                  }
                />
              ) : (
                <Typography variant="h3" component="div">
                  تیکت موجود نیست
                </Typography>
              )}
            </>
          )}
          <Grid item xs={12} sm={12} style={{ marginTop: '24px' }}>
            {finalizedTicketsList?.length > 0 && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  count={Math.ceil(
                    props.ticketCountList / filtersValues.size
                  )}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </Grid>
      </div>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogContent style={{ paddingTop: '0' }}>
              <Grid item md={12} lg={12}>
                <div style={{ marginTop: '2px' }}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="title"
                    label="عنوان"
                    error={errors.title}
                    rules={{ required: true, minLength: 4 }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                      />
                    }
                  />
                </div>
                {errors.title?.type == "required" && <FormHelperText error focused>
                  عنوان الزامی می‌باشد
                </FormHelperText>}
                {errors.title?.type == "minLength" && <FormHelperText error focused>
                  حداقل 4کاراکتر وارد شود
                </FormHelperText>}
              </Grid>
              <br></br>
              <Grid container direction="row" spacing={2}>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="type"
                    name="type"
                    label="مربوط به"
                    error={errors.type}
                    rules={{ required: false }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                      >
                        {ticketType.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              {item.title}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                </Grid>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="parcel-order-number"
                    label="شماره سفارش یا محموله"
                    error={errors['parcel-order-number']}
                    rules={{ required: watch('type') != "NONE", pattern: /[0-9]/ }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        disabled={watch('type') == "NONE"}
                      ></TextField>
                    }
                  />
                  {errors['parcel-order-number']?.type == "required" && <FormHelperText error focused>
                    شناسه سفارش یا محموله الزامی می‌باشد
                  </FormHelperText>}
                  {errors['parcel-order-number']?.type == "pattern" && <FormHelperText error focused>
                    فقط عدد وارد شود
                  </FormHelperText>}
                </Grid>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="priority"
                    name="priority"
                    label="اولویت"
                    error={errors.priority}
                    rules={{ required: true }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                      >
                        {ticketPriority.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              <Chip
                                icon={
                                  <RonadIcons name='circleMedium' size={0.6} style={{color: item.color}}/>
                                }
                                label={item.title}
                                style={{
                                  color: item.color,
                                  backgroundColor: item.bcolor,
                                  fontSize: '16px',
                                }}
                              />
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                  <FormHelperText error focused>
                    {errors.priority && 'اولویت الزامی می‌باشد'}
                  </FormHelperText>
                </Grid>
              </Grid>

              <Grid container direction="row" spacing={2}>
                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="department"
                    options={depts}
                    getOptionLabel={option => option.name}
                    disableClearable={true}
                    onChange={(e: any, newValue: any | null | undefined) => {
                      if (newValue) {
                        setActiveDepartment(newValue.helpicalId);
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        name="department"
                        inputRef={register({ required: true })}
                        {...params}
                        label="دسته‌بندی"
                        fullWidth
                        variant="outlined"
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.department && 'دسته‌بندی الزامی میباشد'}
                  </FormHelperText>

                  {/* <Controller
                    style={{width: '100%'}}
                    control={control}
                    name="category"
                    label="دسته‌بندی"
                    rules={{required: true}}
                    onChange={e => {
                      console.log(e.target.value);
                    }}
                    as={
                      <TextField
                        style={{marginTop: '16px', marginBottom: '16px'}}
                        fullWidth
                        variant="outlined"
                        select
                      >
                        {depts.map(item => {
                          return (
                            <MenuItem value={item.helpicalId}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  /> */}
                </Grid>

                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="category"
                    options={categories}
                    disabled={!activeDepartment}
                    onChange={(event: any, newValue: any | null) => {
                      // console.log("New value: ", newValue, "its id: ", newValue.id)
                      setCategory(newValue.id);
                    }}
                    getOptionLabel={option => option?.name}
                    disableClearable={true}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        {...params}
                        inputRef={register({ required: true })}
                        label="موضوع"
                        variant="outlined"
                        name="category"
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.category && 'موضوع الزامی میباشد'}
                  </FormHelperText>
                </Grid>
              </Grid>

              {/* <Controller
                    style={{width: '100%'}}
                    control={control}
                    name="category"
                    label="موضوع"
                    rules={{required: true}}
                    as={
                      <TextField
                        style={{marginTop: '16px', marginBottom: '16px'}}
                        fullWidth
                        variant="outlined"
                        select
                        disabled={!activeDepartment}
                      >
                        {categories?.map(item => {
                          return (
                            <MenuItem value={item.id}>{item.name}</MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                      
                      <FormHelperText error focused>
              {errors.department &&
                'دسته‌بندی الزامی میباشد'}
            </FormHelperText>
              */}

              <Controller
                control={control}
                id="msg"
                name="msg"
                rules={{ required: true }}
                error={errors.msg}
                as={
                  <TextField
                    inputProps={{
                      style: {
                        minHeight: '120px',
                        maxHeight: '240px',
                        padding: '0 8px',
                      },
                    }}
                    margin="normal"
                    multiline
                    label="متن پیام"
                    variant="outlined"
                    fullWidth
                  />
                }
              />

              <FormHelperText error focused>
                {errors.msg && 'متن پیام الزامی است'}
              </FormHelperText>

              <Grid container direction="row" spacing={2}>
                <Grid item md={12} lg={12}>
                  <RonadDropzone
                    register={register}
                    onDropped={handleFileDropped}
                  />
                </Grid>
              </Grid>
              {file && (
                <Grid
                  style={{
                    textAlign: 'left',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <IconButton
                    aria-label="close"
                    style={{ marginLeft: 'auto' }}
                    onClick={handleRemoveFile}
                  >
                    <RonadIcons name="times" className='text-danger'  size={0.8}/>
                  </IconButton>
                  <span style={{ marginTop: '14px' }}>
                    <span style={{ fontWeight: 'bold' }}> {file.name} </span>
                    <span>( {file.size} KB )</span>
                  </span>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={1}
                direction="row-reverse"
                style={{ marginBottom: '8px' }}
              >
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    style={{ marginLeft: '24px' }}
                    disabled={loading}
                  >

                    {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
                  </Button>
                </Grid>

                {handleCloseModal ? (
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      color="default"
                      onClick={handleCloseModal}
                    >
                      {`بازگشت`}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </DialogActions>
          </form>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ticketCountList: makeSelectTicketCountList(),
  ticketsList: makeSelectTicketsList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ticketDispatch: (payload: Payload) => dispatch(getTicketsAction(payload)),
    ticketCountDispatch: (payload: Payload) =>
      dispatch(getTicketsCountAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Helpdesk);